angular.module('tgaAdmin').controller('BannerNotificationsController', [
  'bannerNotificationsService',
  'rootScopeCacheService',
  '$scope',
  'localStorageService',
  'userService',
  function (bannerNotificationsService, rootScopeCacheService, $scope, localStorageService, userService) {
    $scope.viewmodel = {
      temp_dismissed: localStorageService.get('tempDismissedBanners'),
      userShouldNotSeeBanners: userService.checkUserType(['user', 'editor', 'viewer_admin', 'creator_admin', 'admin']),
    };

    if (angular.isUndefined(rootScopeCacheService.get('banners')) && !$scope.viewmodel.userShouldNotSeeBanners) {
      bannerNotificationsService.startBannerPolling();
    }
    this.dismiss = (index) => {
      const banners = rootScopeCacheService.get('banners');
      const banner = banners.splice(index, 1)[0];
      rootScopeCacheService.set('banners', banners);
      if (banner.banner_type !== 1) {
        if ($scope.viewmodel.temp_dismissed === null || !$scope.viewmodel.temp_dismissed.toString().includes(banner.banner_id)) {
          $scope.viewmodel.temp_dismissed = $scope.viewmodel.temp_dismissed === null
            ? banner.banner_id : `${$scope.viewmodel.temp_dismissed}, ${banner.banner_id}`;
          localStorageService.set('tempDismissedBanners', $scope.viewmodel.temp_dismissed);
        }
      } else {
        bannerNotificationsService.dismiss(banner.banner_id);
      }
    };
  },
]);
